import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import { HeaderText, Stack } from '../../ui';
import BodyText from '../../ui/BodyText';
import Address from './Address';
import { googleMapURL } from '../../../modules/maps/location';
import './SidebarLocation.module.scss';
import { ClientProviderProfile } from '../../../api/ProfileClientView';
import ExternalLink from '../../ui/ExternalLink';

type LocationProps = {
  profile: ClientProviderProfile;
};

export const Location = (
  {
    profile,
  }: LocationProps,
) => {
  const props = {
    address1: profile?.address1,
    address2: profile?.address2,
    zipcode: profile?.zipcode,
    city: profile?.city,
    state: profile?.state,
  };
  return (
    <Stack
      justifyContent="flex-start"
      space={8}
    >
      <HeaderText
        level="3"
        testID="Location_section"
        color={BrandColor.BackInBlack}
      >
        Location
      </HeaderText>
      {/* business name */}
      <BodyText testID="pro_business_name" color={BrandColor.Metal}>{profile?.name}</BodyText>
      {/* address */}
      <ExternalLink
        href={googleMapURL(props)}
        trackingParams={{
          eventName: 'client_proprofile_address_click',
        }}
      >
        <Address
          mobileBusiness={profile?.mobile_business}
          address1={profile?.address1}
          address2={profile?.address2}
          zipCode={profile?.zipcode}
          city={profile?.city}
          state={profile?.state}
          renderText={({ children }) => (
            <BodyText
              appearance="normal"
              color={BrandColor.Metal}
            >{children}
            </BodyText>
          )}
        />
      </ExternalLink>
      {/* phone nummber */}
      {profile?.public_phone_number ? (
        <Box>
          <BodyText color={BrandColor.Metal}>{profile?.public_phone_number} </BodyText>
        </Box>
      ) : null}
    </Stack>
  );
};
